import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "kam-form-create" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Formulier "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Project "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)

import PageTitleBar from '@/components/PageTitleBar.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted, ref } from 'vue'
import { forms, getKamFormById } from '@/views/kam/formResigstry'
import kamStore from '@/stores/kam.ts'

type ProjectOption = { id: number, name: string, reference?: string, label?: string }


export default /*#__PURE__*/_defineComponent({
  __name: 'KAMFormCreate',
  setup(__props) {

const router = useRouter()
const loading = ref(false)
const projectsLoading = ref(false)

const projects = ref<ProjectOption[]>([])
const preloadedProjects = ref<ProjectOption[]>([])
const kamForm = ref<{form:number|null, project_id:number|null}>({ form: null, project_id: null })
let projectTimer = 0
let projectSearchRequest = 0
let lastProjectSearch = ''

const projectOptions = computed<ProjectOption[]>(() => {
  return projects.value.map((project) => ({
    ...project,
    label: project.reference ? `${project.name} (${project.reference})` : project.name
  }))
})

onMounted(() => {
  getProjects()
})

async function getProjects () : Promise<void> {
  projectsLoading.value = true

  try {
    const result = await kamStore().getProjects() as ProjectOption[]
    preloadedProjects.value = result
    projects.value = result
  } catch {
    preloadedProjects.value = []
    projects.value = []
  } finally {
    projectsLoading.value = false
  }
}

function searchProjects (val:string) : void {
  const search = val.trim()
  clearTimeout(projectTimer)

  if (search.length < 3) {
    lastProjectSearch = ''
    projectSearchRequest++
    projects.value = preloadedProjects.value
    projectsLoading.value = false
    return
  }

  if (search === lastProjectSearch) return

  projectsLoading.value = true
  const requestId = ++projectSearchRequest

  projectTimer = setTimeout(async () => {
    lastProjectSearch = search

    try {
      const result = await kamStore().getProjects(search, 50) as ProjectOption[]
      if (requestId === projectSearchRequest) projects.value = result
    } catch {
      if (requestId === projectSearchRequest) projects.value = []
    } finally {
      if (requestId === projectSearchRequest) projectsLoading.value = false
    }
  }, 500)
}

async function addKAMForm () : Promise<void> {
  loading.value = true

  try {
    const selectedForm = getKamFormById(kamForm.value.form)
    const payload = {
      form_reference: selectedForm?.reference ?? null,
      form_template_id: selectedForm?.id ?? null,
      form_name: selectedForm?.name ?? 'KAM Formulier',
      form_version: selectedForm?.version ?? 1,
      project_id: kamForm.value.project_id
    }
    const data = await kamStore().createForm(payload)

    router.push({
      name: 'KAMFormEdit',
      params: {
        kamFormId: data.id,
        formReference: data.form?.reference ?? selectedForm?.reference ?? '',
        projectReference: data.project?.reference ?? ''
      }
    })
  } catch {
    // notification handled by the store
  } finally {
    loading.value = false
  }
}

function filterByName (input:string, record:{ id:number, name:string }) {
  return record.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

const allRequiredFilled = computed<boolean>(() => {
  return !!(kamForm.value.form && kamForm.value.project_id)
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageTitleBar, null, {
      title: _withCtx(() => [
        _createTextVNode("KAM formulier toevoegen.")
      ]),
      buttons: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          disabled: !_unref(allRequiredFilled) || loading.value,
          loading: loading.value,
          onClick: addKAMForm
        }, {
          default: _withCtx(() => [
            _createTextVNode("Toevoegen")
          ]),
          _: 1
        }, 8, ["disabled", "loading"]),
        _createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'KAMForms' })))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Terug naar overzicht")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { title: "Details" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, { gutter: [16,16] }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _hoisted_2,
                        _createVNode(_component_a_select, {
                          placeholder: "Selecteer een formulier",
                          value: kamForm.value.form,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((kamForm.value.form) = $event)),
                          fieldNames: { label: 'name', value: 'id' },
                          "filter-option": filterByName,
                          options: _unref(forms),
                          "show-search": ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _hoisted_3,
                        _createVNode(_component_a_select, {
                          value: kamForm.value.project_id,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((kamForm.value.project_id) = $event)),
                          placeholder: "Begin met typen om te zoeken..",
                          fieldNames: { label: 'label', value: 'id' },
                          "filter-option": false,
                          loading: projectsLoading.value,
                          "not-found-content": projectsLoading.value ? 'Projecten laden...' : null,
                          options: _unref(projectOptions),
                          onSearch: searchProjects,
                          "show-search": ""
                        }, null, 8, ["value", "loading", "not-found-content", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})